import { Identifiable, Event, Resource } from "@planzone/dto";
import { LinkedEvent } from "../linkers/types";
import { HttpClient, HttpMethods } from "../types/httpClient";
import { mapError } from "../utils/mapError";

function didOrganizerChanged(
  organizer: Identifiable<Resource>,
  nextOrganizer: Identifiable<Resource>,
) {
  return organizer && nextOrganizer && organizer.uuid !== nextOrganizer.uuid;
}

function didParticipantsChanged(
  participants: Identifiable<Resource>[],
  nextParticipants: Identifiable<Resource>[],
) {
  return (
    participants.some(
      (participant) =>
        !nextParticipants.find(({ uuid }) => participant.uuid === uuid),
    ) ||
    nextParticipants.some(
      (participant) =>
        !participants.find(({ uuid }) => participant.uuid === uuid),
    )
  );
}

function editEvent(httpClient: HttpClient) {
  return (event: Identifiable<Event>, nextEvent: Event) =>
    httpClient
      .sendHttpRequest<LinkedEvent>({
        endpoint: `/events/${event.uuid}`,
        method: HttpMethods.PATCH,
        data: {
          name: nextEvent.name,
          description: nextEvent.description,
          keyRank: nextEvent.keyRank,
          ...(nextEvent.startTime && {
            startTime: nextEvent.startTime,
          }),
          ...(nextEvent.endTime && { endTime: nextEvent.endTime }),
          ...(didOrganizerChanged(event.organizer, nextEvent.organizer) && {
            organizer: `/resources/${nextEvent.organizer.uuid}`,
          }),
          ...(nextEvent.location && {
            location: `/resources/${nextEvent.location.uuid}`,
          }),
          ...(nextEvent.parentList && {
            parentActivity: `/activities/${nextEvent.parentList.uuid}`,
          }),
          ...(didParticipantsChanged(
            event.participants,
            nextEvent.participants,
          ) && {
            participants: nextEvent.participants.map(
              ({ uuid }) => `/resources/${uuid}`,
            ),
          }),
          ...(!!nextEvent.attributes && {
            attributes: nextEvent.attributes,
          }),
        },
      })
      .catch((e) =>
        Promise.reject(
          mapError(e, {
            emptyName: "emptyName",
            duplicateName: "duplicateName",
            invalidDateRange: "invalidDateRange",
            startDateOutOfBound: "startDateOutOfBound",
            notFound: "notFound",
            listNotFound: "listNotFound",
          }),
        ),
      );
}

export { editEvent };
